import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { medicalServiceService, workstationService } from 'shared/services';
import { Option } from 'shared/types/general';
import toast from 'shared/utils/toast';
import { MedicalServicesForm } from '../components/MedicalServicesForm';
import { useMedicalServiceMetadata } from '../hooks/useMedicalServiceMetadata';

export const CreateMedicalService = () => {
  const [workstations, setWorkstations] = useState<Option[]>([]);

  const { exams, exam, setExam, laboratories, lab, setLab } = useMedicalServiceMetadata();

  useEffect(() => {
    if (!exam?.id || !lab?.code) {
      setWorkstations([]);
      return;
    }

    workstationService
      .getAllBaseInformation({ exam: exam.id, laboratory: lab.code })
      .then(setWorkstations);
  }, [exam, lab]);

  const onSubmitCreate = async (values) => {
    medicalServiceService.generateLines(values).then(() => {
      toast.success('Prestazioni mediche aggiunte.');
    });
  };

  return (
    <TenantPage title={'Inserisci Nuova Prestazione'}>
      <MedicalServicesForm
        onSubmitCreate={onSubmitCreate}
        exams={exams}
        setExam={setExam}
        laboratories={laboratories}
        setLab={setLab}
        workstations={workstations}
      />
    </TenantPage>
  );
};

export default CreateMedicalService;
